class DinKlaviyoNewsletter extends HTMLElement {
  connectedCallback() {
    this._loadedAt = Date.now();

    this._form = this.querySelector('form');
    this._emailInput = this._form.querySelector('input[type="email"]');
    this._honeypot = this._form.querySelector('input[name="website"]');
    this._submitBtn = this._form.querySelector('button[type="submit"]');
    this._statusEl = this.querySelector('.din-klaviyo-newsletter__status');
    this._formInner = this._form.querySelector('.newsletter-compact__signup-inner');

    this._form.addEventListener('submit', (event) => this.handleSubmit(event));
  }

  async handleSubmit(event) {
    event.preventDefault();

    // Honeypot check — silently fake success if filled
    if (this._honeypot && this._honeypot.value.trim().length > 0) {
      this.showSuccess();
      return;
    }

    // Timing check — reject submissions faster than 1.5s after element load
    if (Date.now() - this._loadedAt < 1500) {
      this.showSuccess();
      return;
    }

    // Native validation
    if (!this._form.checkValidity()) {
      this._form.reportValidity();
      return;
    }

    const apiKey = this.dataset.apiKey;
    const listId = this.dataset.listId;

    // Guard: missing required config
    if (!apiKey || !listId) {
      this.showError('Newsletter configuration is incomplete.');
      return;
    }

    const email = this._emailInput.value.trim();
    const customSource = this.dataset.customSource;
    const customPropKey = this.dataset.customPropKey;
    const customPropValue = this.dataset.customPropValue;

    // Build profile attributes
    const profileAttributes = {
      email: email,
      subscriptions: {
        email: {
          marketing: {
            consent: 'SUBSCRIBED'
          }
        }
      }
    };

    // Add custom property if key is provided
    if (customPropKey) {
      profileAttributes.properties = {
        [customPropKey]: customPropValue || ''
      };
    }

    // Build request body
    const body = {
      data: {
        type: 'subscription',
        attributes: {
          profile: {
            data: {
              type: 'profile',
              attributes: profileAttributes
            }
          }
        },
        relationships: {
          list: {
            data: {
              type: 'list',
              id: listId
            }
          }
        }
      }
    };

    // Add custom_source if provided
    if (customSource) {
      body.data.attributes.custom_source = customSource;
    }

    this.setLoading(true);

    try {
      const response = await fetch(
        `https://a.klaviyo.com/client/subscriptions?company_id=${encodeURIComponent(apiKey)}`,
        {
          method: 'POST',
          headers: {
            'content-type': 'application/vnd.api+json',
            'accept': 'application/vnd.api+json',
            'revision': '2026-01-15'
          },
          body: JSON.stringify(body)
        }
      );

      if (response.status === 202) {
        this.showSuccess();
      } else {
        this.showError();
      }
    } catch {
      this.showError();
    }
  }

  setLoading(loading) {
    if (this._submitBtn) {
      this._submitBtn.disabled = loading;
    }
  }

  showSuccess() {
    const message = this.dataset.successMessage || 'Thanks for subscribing!';
    this._statusEl.innerHTML = `<span class="form-status__message form-status__message--success">${this.escapeHtml(message)}</span>`;
    this._statusEl.querySelector('.form-status__message').focus();
    if (this._formInner) {
      this._formInner.style.display = 'none';
    }
    this.setLoading(false);
  }

  showError(customMessage) {
    const message = customMessage || this.dataset.errorMessage || 'Something went wrong. Please try again.';
    this._statusEl.innerHTML = `<span class="form-status__message form-status__message--error">${this.escapeHtml(message)}</span>`;
    this.setLoading(false);
  }

  escapeHtml(str) {
    const div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML;
  }
}

customElements.define('din-klaviyo-newsletter', DinKlaviyoNewsletter);
